import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { createPromotionalCode } from "../api/createPromotionalCode";

export const useCreatePromotionalCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => createPromotionalCode(body),
    onSuccess: () => {
      toast.success("Promotional code created successfully!");
      queryClient.invalidateQueries({ queryKey: ["promotionalCodes"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to create promotional code.");
    },
  });
};

